const groupArray = (set, amount) => set.reduce((a, b, idx, array) => (idx % amount === 0 ? [...a, array.slice(idx, idx + amount)] : [...a]), []);

export default groupArray;
